export enum CompanyTaxRuleType {
FlatRate,
Scaled,
}
